module.exports = __webpack_public_path__ + "static/media/provider-03.2ea93aca.png";